import { VideoPlayer } from './video-player.interface';

export class NativeVideoPlayer implements VideoPlayer {
    private video: HTMLVideoElement;
    private playCb: () => void;
    private pauseCb: () => void;
    private endedCb: () => void;

    async load(container: HTMLElement, url: string, startPosition: number): Promise<void> {
        this.video = document.createElement('video');
        this.video.src = url;
        this.video.controls = true;
        this.video.style.width = '100%';
        container.appendChild(this.video);

        if (startPosition > 0) {
            await new Promise<void>((resolve) => {
                const onMeta = () => {
                    this.video.currentTime = startPosition;
                    this.video.removeEventListener('loadedmetadata', onMeta);
                    resolve();
                };
                this.video.addEventListener('loadedmetadata', onMeta);
            });
        }
    }

    async getPosition(): Promise<number> {
        return this.video?.currentTime ?? 0;
    }

    async pause(): Promise<void> {
        this.video?.pause();
    }

    destroy(): void {
        if (this.video) {
            if (this.playCb) this.video.removeEventListener('play', this.playCb);
            if (this.pauseCb) this.video.removeEventListener('pause', this.pauseCb);
            if (this.endedCb) this.video.removeEventListener('ended', this.endedCb);
            this.video.src = '';
            this.video.remove();
        }
    }

    onPlay(cb: () => void): void {
        this.playCb = cb;
        this.video?.addEventListener('play', cb);
    }

    onPause(cb: () => void): void {
        this.pauseCb = cb;
        this.video?.addEventListener('pause', cb);
    }

    onEnded(cb: () => void): void {
        this.endedCb = cb;
        this.video?.addEventListener('ended', cb);
    }
}
